// -----------------------------------------------------------------------------
// HistoryPage — Historique (mouvements + pertes/casses)
// StockPro / VisualisPro
// -----------------------------------------------------------------------------

import { T } from "../../i18n/translations";
import { getColors } from "../../styles/theme";

export default function HistoryPage({
  lang,
  dark,
  accent,
  historyLogs,
  pertesLogs,
  historyTab,
  setHistoryTab,
  pertesFilter,
  setPertesFilter,
}) {
  const t = T[lang];
  const { textPrimary, textSecondary, borderColor } = getColors(dark);

  return (
    <div className="slide-in">
      <div style={{ marginBottom:20 }}>
        <h1 style={{ fontSize:22, fontWeight:800, color:textPrimary }}>{t.history}</h1>
        <p style={{ color:textSecondary, fontSize:12, marginTop:2 }}>
          Traçabilité Firestore — {historyTab==="mouvements" ? historyLogs.length : pertesLogs.length} entrées
        </p>
      </div>

      {/* Onglets */}
      <div style={{ display:"flex", gap:8, marginBottom:16 }}>
        <button
          onClick={() => setHistoryTab("mouvements")}
          style={{ padding:"8px 16px", borderRadius:9, fontSize:13, fontWeight:600, background:historyTab==="mouvements"?`${accent}20`:dark?"rgba(255,255,255,.04)":"rgba(0,0,0,.04)", color:historyTab==="mouvements"?accent:textSecondary, border:`1px solid ${historyTab==="mouvements"?accent+"40":borderColor}`, cursor:"pointer" }}
        >
          📋 Mouvements
        </button>
        <button
          onClick={() => setHistoryTab("pertes")}
          style={{ padding:"8px 16px", borderRadius:9, fontSize:13, fontWeight:600, background:historyTab==="pertes"?"rgba(239,68,68,.2)":dark?"rgba(255,255,255,.04)":"rgba(0,0,0,.04)", color:historyTab==="pertes"?"#f87171":textSecondary, border:`1px solid ${historyTab==="pertes"?"rgba(239,68,68,.4)":borderColor}`, cursor:"pointer" }}
        >
          🗑️ Pertes & Casses ({pertesLogs.length})
        </button>
      </div>

      {/* Filtre pertes */}
      {historyTab === "pertes" && (
        <div style={{ display:"flex", gap:8, marginBottom:14, flexWrap:"wrap" }}>
          {["Tous", "Jeté/Casse", "Périmé"].map(f => (
            <button
              key={f}
              onClick={() => setPertesFilter(f)}
              style={{ padding:"7px 12px", borderRadius:8, fontSize:12, fontWeight:600, background:pertesFilter===f?"rgba(239,68,68,.15)":dark?"rgba(255,255,255,.04)":"rgba(0,0,0,.04)", color:pertesFilter===f?"#f87171":textSecondary, border:`1px solid ${pertesFilter===f?"rgba(239,68,68,.3)":borderColor}`, cursor:"pointer" }}
            >
              {f}
            </button>
          ))}
        </div>
      )}

      {historyTab === "mouvements" ? (
        historyLogs.length === 0 ? (
          <div className="card" style={{ padding:"40px", textAlign:"center", color:textSecondary }}>{t.noHistory}</div>
        ) : (
          <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
            {historyLogs.slice(0, 50).map(log => (
              <div key={log.id} className="card" style={{ padding:"11px 15px" }}>
                <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between" }}>
                  <div>
                    <div style={{ fontWeight:600, color:textPrimary, fontSize:13 }}>{log.productName}</div>
                    <div style={{ fontSize:10, color:textSecondary, marginTop:2 }}>
                      {log.createdAt?.toDate?.()?.toLocaleString("fr-BE") || "..."}
                    </div>
                  </div>
                  <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                    <span style={{ fontSize:12, color:textSecondary, fontFamily:"'JetBrains Mono',monospace" }}>
                      {log.before} → {log.after} {log.unit}
                    </span>
                    <span style={{ fontSize:13, fontWeight:700, fontFamily:"'JetBrains Mono',monospace", color:log.action.startsWith("+")||log.action.includes("Inventaire +")?"#10b981":"#f87171" }}>
                      {log.action}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )
      ) : (
        (() => {
          const filtered = pertesFilter === "Tous" ? pertesLogs : pertesLogs.filter(p => p.reason === pertesFilter);
          return filtered.length === 0 ? (
            <div className="card" style={{ padding:"40px", textAlign:"center", color:textSecondary }}>Aucune perte enregistrée</div>
          ) : (
            <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
              {filtered.map(log => (
                <div key={log.id} className="card" style={{ padding:"11px 15px", borderColor:"rgba(239,68,68,.2)" }}>
                  <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between" }}>
                    <div>
                      <div style={{ fontWeight:600, color:textPrimary, fontSize:13 }}>{log.productName}</div>
                      <div style={{ fontSize:10, color:textSecondary, marginTop:2 }}>
                        {log.createdAt?.toDate?.()?.toLocaleString("fr-BE") || "..."}
                      </div>
                    </div>
                    <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                      <span style={{ fontSize:12, color:textSecondary, fontFamily:"'JetBrains Mono',monospace" }}>
                        -{log.quantity} {log.unit}
                      </span>
                      <span style={{ padding:"3px 10px", borderRadius:20, fontSize:11, fontWeight:600, background:log.reason==="Périmé"?"rgba(245,158,11,.15)":"rgba(239,68,68,.15)", color:log.reason==="Périmé"?"#fbbf24":"#f87171" }}>
                        {log.reason==="Périmé" ? "⏰" : "🗑️"} {log.reason}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          );
        })()
      )}
    </div>
  );
}
